export default [
	/**
	 * 支付配置模块
	 */
	{
		path: "payDomain",
		name: "PAY_DOMAIN",
		meta: {
			title: "淘滩支付地址配置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/basics/payDomain.vue"),
	},
	{
		path: "commercial",
		name: "COMMERCIAL_INFO",
		meta: {
			title: "商户信息",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/basics/commercial.vue"),
	},
	{
		path: "paymentType",
		name: "PAYMENT_TYPE",
		meta: {
			title: "支付类型",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/basics/paymentType.vue"),
	},
	{
		path: "Complaintlist",
		name: "Complaint_list",
		meta: {
			title: "商户投诉",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/basics/ComplaintList.vue"),
	},

	{
		path: "companyAdmin",
		name: "COMPANY_ADMIN",
		meta: {
			title: "公司管理",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/company/companyAdmin.vue"),
	},
	{
		path: "service",
		name: "SERVICE_CONFIGURATION",
		meta: {
			title: "客服配置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/company/service.vue"),
	},

	{
		path: "agreement",
		name: "AGREEMENT_CONFIGURATION",
		meta: {
			title: "协议配置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/company/agreement.vue"),
	},
	{
		path: "help",
		name: "HELP_CONFIGURATION",
		meta: {
			title: "帮助中心",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/company/help.vue"),
	},
	/**
	 * 渠道模块
	 */
	{
		path: "channelAccount",
		name: "CHANNEL_ACCOUNT",
		meta: {
			title: "渠道账号",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/channel/channelAccount.vue"),
	},
	{
		path: "channelDealerInfo",
		name: "CHANNEL_DEALER_INFO",
		meta: {
			title: "渠道商信息",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/channel/channelDealerInfo.vue"),
	},
	{
		path: "channelType",
		name: "CHANNEL_TYPE",
		meta: {
			title: "渠道类型",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/channel/channelType.vue"),
	},

	/**
	 * 业务模块
	 */
	{
		path: "businessName",
		name: "BUSINESS_NAME",
		meta: {
			title: "投放域名",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/domain_name/businessName.vue"),
	},

	{
		path: "payName",
		name: "PAY_NAME",
		meta: {
			title: "支付域名",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/domain_name/payName.vue"),
	},
	{
		path: "recordsName",
		name: "RECORDS_NAME",
		meta: {
			title: "备案域名",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/domain_name/recordsName.vue"),
	},
	/**
	 * 广告模块
	 */

	{
		path: "advertisingLibrary",
		name: "ADVERTISING_LIBRARY",
		meta: {
			title: "广告库",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/advertising/advertisingLibrary.vue"),
	},
	{
		path: "advertisingLocation",
		name: "ADVERTISING_LOCATION",
		meta: {
			title: "广告位置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/advertising/advertisingLocation.vue"),
	},

	// 客户支持
	{
		path: "searchOrderList",
		name: "KEFU_ORDER_LIST",
		meta: {
			title: "订单查询",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/kefuInfo/searchOrderList.vue"),
	},
	{
		path: "searchUserList",
		name: "KEFU_USER_LIST",
		meta: {
			title: "用户查询",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/kefuInfo/searchUserList.vue"),
	},

	/**
	 * 问题反馈模块
	 */

	{
		path: "commonProblem",
		name: "COMMON_PROBLEM",
		meta: {
			title: "常见问题",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/problemView/commonProblem.vue"),
	},
	{
		path: "feedbackType",
		name: "FEEDBACK_TYPE",
		meta: {
			title: "反馈类型",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/problemView/feedbackType.vue"),
	},

	{
		path: "language",
		name: "LANGUAGE",
		meta: {
			title: "语言管理",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/language.vue"),
	},
	{
		path: "currency",
		name: "CURRENCY",
		meta: {
			title: "币种管理",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/currency.vue"),
	},
	{
		path: "plate",
		name: "PLATE",
		meta: {
			title: "版快管理",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/country/plate.vue"),
	},
	{
		path: "countryList",
		name: "COUNTRY_LIST",
		meta: {
			title: "国家列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/country/countryList.vue"),
	},
	{
		path: "countryList",
		name: "COUNTRY_LIST",
		meta: {
			title: "国家列表",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/country/countryList.vue"),
	},
	{
		path: "emailConfig",
		name: "EMAIL_CONFIG",
		meta: {
			title: "邮件模板",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/email/emailConfig.vue"),
	},
	{
		path: "emailConfig",
		name: "EMAIL_CONFIG",
		meta: {
			title: "STMP设置",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/email/emailConfig.vue"),
	},
	{
		path: "emailTemplate",
		name: "EMAIL_TEMPLATE",
		meta: {
			title: "邮件模板",
			icon: "",
			isNav: true,
		},
		component: () => import("@/views/international/email/emailTemplate.vue"),
	},
];
